import { ReactElement, memo, useState } from "react"
import styled from "styled-components"

import EventTypesTable from "./EventTypesTable"
import EventTypesHeader from "./component/EventTypesHeader"
import { EventModal } from "./modals/EventModal"

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.theme.palette.gray_ice};
  margin-top: 48px;
  gap: 32px;
  overflow: hidden;
`
const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
`

const EventTypes = (): ReactElement => {
  const [filterValue, setFilterValue] = useState<string>("")
  const [hasData, setHasData] = useState(true)

  return (
    <Container>
      <InnerContainer>
        <EventTypesHeader hasData={hasData} filterValue={filterValue} setFilterValue={setFilterValue} />
        <EventTypesTable hasData={hasData} filterValue={filterValue} setHasData={setHasData} />
      </InnerContainer>
      <EventModal />
    </Container>
  )
}

export default memo(EventTypes)
